// extracted by mini-css-extract-plugin
module.exports = {"container":"OrdersTabBadge_container__14tZ3","container-ltr":"OrdersTabBadge_container-ltr__zQuhi"};